<template>
  <b-card no-body class="overflow-hidden m-0 p-0">
    <b-row no-gutters>
      <b-col class="hw-fixed">
        <job-media-wrapper :job="job"></job-media-wrapper>
      </b-col>
      <b-col align-self="center" class="col-width">
        <b-card-body class="pb-2 pt-2 text-truncate text-center align-items-center" >
          <div>
            <router-link :to="{ name: 'Job Details', params: { jobId: job.jobId }}"><h5 class="card-title m-0 ">{{name}}</h5></router-link>
            <div>
              <small class="text-muted">{{ job.dateStarted | moment("from") }}</small>
            </div>
            <div class="pt-1">
              <report-button-set :jobItem=job></report-button-set>
            </div>
          </div>
        </b-card-body>
      </b-col>
      <manifest-cart-add-remove-item :entity="job"></manifest-cart-add-remove-item>
    </b-row>
  </b-card>
</template>

<script>

import ReportButtonSet from '#/ui/Components/ReportButtonSet.vue';
import { derivativeThumbsForJob } from '#/models/jobs/derivatives';
import ManifestCartAddRemoveItem from './Manifest/ManifestCartAddRemoveItem.vue';
import { EntityId } from '../../protobuf/general_pb';
import JobMediaWrapper from './Jobs/JobMediaWrapper.vue';

export default {
  components: {
    ReportButtonSet,
    ManifestCartAddRemoveItem,
    JobMediaWrapper,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allIds: [],
    };
  },
  created() {
    const derivs = this.job.expandedMediaDerivativesList;
    if (derivs.length === 0) {
      return;
    }
    console.log('derivs', derivs);
    derivs.forEach((d) => {
      const { size } = d.output;
      const checksum = d.output.checksums.xxhash3128;
      console.log('calculated media deriv id:', size, checksum);
      const entityId = new EntityId();
      entityId.setSize(size);
      entityId.setChecksum(checksum);
      this.allIds.push(entityId);
    });
  },
  methods: {
    openFile() {
      console.log('open job clicked', this.job);
      const path = `/jobs/${this.job.jobId}`;
      this.$router.push(path);
    },
  },
  computed: {
    name() {
      // properly make sure this stays as one row. and doesn't trigger overflow into a second row
      let name = this.job.name ? this.job.name : '(No Name)';
      if (name.length > 15) {
        name = `${name.substring(0, 15)}...`;
      }
      return name;
    },
    thumb() {
      if (!this.job.keyEntityWasExpanded || !this.job.expandedKeyEntity || this.job.expandedKeyEntity.expandedThumbnailsList.length < 1) {
        console.log('no thumb for job', this.job.jobId);
        return undefined;
      }
      const [thumb] = this.job.expandedKeyEntity.expandedThumbnailsList;
      return thumb.signedUrl;
    },
    derivativeThumbs() {
      return derivativeThumbsForJob(this.job);
    },
  },
};

</script>

<style scoped lang="scss">
.hw-fixed{
  width: 274px;
}
</style>
